/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { GlobalDashboardLayout } from '../../../../layouts';
import { Section } from '../../../../global';
import { AddEditInitialiseStaffModal } from '../Staff/modules';
import { repository } from '@whizz/api-client';
import { QUERIES_IDS } from '../../../../util/vars';
import { useQuery } from 'react-query';
import type { NewTeacherInterface } from '@whizz/api-model';
import { splitPhone } from '../../../../util/phone';

const PasswordInitialisation = (): JSX.Element => {
  const { translate } = useI18n();

  const teacherQuery = useQuery<NewTeacherInterface>(
    [ QUERIES_IDS.PASSWORD_INITIALISATION, 'getTeacher' ],
    () => repository.NewTeacherRepository.getLoggedTeacher(),
    {
      enabled: true,
    },
  );

  const [ phoneNationalCode, phoneNumber ] = splitPhone(teacherQuery.data?.phone);

  return (
    <GlobalDashboardLayout
      title={translate('pages.PASSWORD.HEADER')}
      settings={<></>}
      disableContainer
      hideMenu
    >
      <Section className={'w-full md:w-4/5 lg:w-1/2 mx-auto'}>
        <div className={'container'}>
          <h1 className={'mb-4 text-3xl'}>{translate('pages.PASSWORD.WELCOME')}</h1>
          <p className={'mb-10'}>{translate('pages.PASSWORD.CHECK_DETAILS')}</p>
          {null != teacherQuery.data && (
            <AddEditInitialiseStaffModal
              mode={'init'}
              data={{ ...teacherQuery.data, phoneNationalCode, phoneNumber }}
              toggle={() => { /* Do nothing */ }}
              toggleConfirm={() => { /* Do nothing */ }}
            />
          )}
        </div>
      </Section>
    </GlobalDashboardLayout>
  );
};

PasswordInitialisation.displayName = 'PasswordInitialisation';

export default PasswordInitialisation;
